(function($, duo, undefined) {

	"use strict";

	/**
	 * @class Paragraphs
	 */
	class Paragraphs {

		/**
		 * Creates an instance of Paragraphs
		 */
		constructor(selector) {
			// setup:
			this.setup();
		} /* constructor */

		setup() {
			// setup video paragraphs:
			this.initializeVideos();
			// setup sliders:
			this.initializeSliders();
			// sideways image captions:
			this.initializeImageCaptions();
		} /* setup */

		/**
		 * Setup video paragraphs
		 */
		initializeVideos() {

			/* setup fancybox */
			/* ************** */

			/* single video */
			/* ------------ */

			$('.js-paragraph-video-link').fancybox({
				loop: true,
				keyboard: true,
				arrows: true,
				infobar: false,
				toolbar: false,
				buttons: [],
				smallBtn: true,
				idleTime : 30,
				wheel: false,
				clickOutside: 'close',
				clickContent: false,
				animationEffect: 'fade',
				animationDuration: 500,
				transitionEffect: 'fade',
				transitionDuration: 366,
				media : {
					youtube : {
						params : {
							autoplay : 1,
							showinfo: 0
						}
					}
				},
				mobile : {
					clickSlide : function( current, event ) {
						return current.type === 'image' ? 'close' : 'close';
					},
					clickContent : function( current, event ) {
						return current.type === 'image' ? 'close' : 'close';
					},
				}
			});

			/* gallery of videos */
			/* ----------------- */

			// to display the video's in a gallery (=> to be able to keep
			// the fancybox open and change between all of the videos),
			// initialize fancybox in the following way:

			// const $fancyboxLinks = $('.js-paragraph-video-link');
			// $fancyboxLinks.on('click', function(e) {
			// 	e.preventDefault();
			// 	$.fancybox.open($fancyboxLinks, {
			// 		// fancybox options
			// 	}, $fancyboxLinks.index( this ) );
			// });

		} /* initializeVideos */

		/**
		 * Setup sliders
		 */
		initializeSliders() {

			/* setup flickity */
			/* ************** */

			$('.paragraph-slider__items').each(function(index, element) {
				const $sliderElement = $(element);

				// get the amount of slides:
				const nrOfSlides = $sliderElement.find('.paragraph-slider__item').length;
				// -> set options depending on the number of slides:
				const showPageDots = nrOfSlides > 1 ? true : false;
				const showNextButtons = nrOfSlides > 1 ? true : false;

				const flickitySlider = $sliderElement.flickity({
 					cellSelector: '.paragraph-slider__item',
					setGallerySize: true,
					initialIndex: 0,
					draggable: '>1',
					wrapAround: true,
					pageDots: showPageDots,
					prevNextButtons: showNextButtons,
					adaptiveHeight: true,
					arrowShape: 'M40.3,5.8 46.6,11.6 15.5,45.5 100,45.5 100,54.1 15.5,54.1 46.6,88.5 40.3,94.2 0,49.8 z'
				});

			});

			/* empty event listener: */
			/* -> the following is important - it makes flickity work better on ios
			 *    see: https://github.com/metafizzy/flickity/issues/457#issuecomment-254501356
			 *    "iOS 10 has a bug where event.preventDefault() will not cancel window scrolling. 
			 *     You can fix this behavior by adding an innocuous event handler."
			 * -> when there's an update of flickity, this may no longer be needed
			 */
			window.addEventListener('touchmove', function() {});
		} /* initializeSliders */

		/**
		 * Setup image captions
		 */
		initializeImageCaptions() {

			// sideways image captions:
			// -> these use writing-mode and they don't properly work
			//    in IE/Edge
			const auparser = new UAParser();
			const auResult =  auparser.getResult();
			// -> browser:
			const browsername = auResult.browser.name;
			let allowSidewaysImageCaptions = true;
			var disallowedBrowsers = ['Edge', 'IE'];
			if(disallowedBrowsers.indexOf(browsername) > -1) {
				allowSidewaysImageCaptions = false;
			}
			if(allowSidewaysImageCaptions) {
				$('body').addClass('js-allow-paragraphs-sideways-captions');
			}

			$('body').addClass('js-paragraphs-captions-processed');

		} /* initializeImageCaptions */

	} /* Paragraphs */

	duo.Paragraphs = Paragraphs;

})(jQuery, window.duo = window.duo || {});
